import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { toast } from 'react-toastify';
import { CheckboxIcon } from './assets/CheckboxIcon';
export default function SuccessToast(message) {
    return (_jsx(React.Fragment, { children: toast.success(message, {
            className: 'success-toast',
            position: toast.POSITION.TOP_CENTER,
            autoClose: 10000,
            theme: 'colored',
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            icon: _jsx(CheckboxIcon, { height: 25, width: 25, fill: "white" }),
        }) }));
}
//# sourceMappingURL=SuccessToast.js.map